import { createEvent, createStore } from 'effector';
import { createInitialEntityState, EntityState, WorkspaceInvite } from '@nx-frontend/shared/types';

export type WorkspaceInvitesState = EntityState<WorkspaceInvite>;
export const setWorkspaceInvitesEvent = createEvent<WorkspaceInvite[]>();

export const $workspaceInvitesState = createStore<WorkspaceInvitesState>(createInitialEntityState()).on(
  setWorkspaceInvitesEvent,
  (state, workspaceInvites) => {
    const entities: Record<string, WorkspaceInvite> = {};
    workspaceInvites.forEach((invite) => {
      entities[invite.id] = invite;
    });
    return { entities, ids: Object.keys(entities) };
  }
);

export const $workspaceInviteEmails = $workspaceInvitesState.map((state) => {
  return Object.values(state.entities).map((invite) => invite.email);
});
